import React, { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import {
  Disc,
  Filter,
  Cog,
  CircleDot,
  Zap,
  Waves,
  BatteryCharging,
  Wind,
  Lightbulb,
  Snowflake,
  Search,
  Loader2,
} from "lucide-react";

const ICONS = {
  disc: Disc,
  filter: Filter,
  cog: Cog,
  "circle-dot": CircleDot,
  zap: Zap,
  waves: Waves,
  "battery-charging": BatteryCharging,
  wind: Wind,
  lightbulb: Lightbulb,
  snowflake: Snowflake,
};

export const PartSearch = ({ categories, onSearch, loading, initialQuery }) => {
  const [query, setQuery] = useState(initialQuery || "");
  const [activeCat, setActiveCat] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) onSearch({ part_query: query.trim(), category_id: activeCat });
  };

  const handleCategory = (cat) => {
    setActiveCat(cat.id);
    const defaultPart = cat.pieces_populaires?.[0] || cat.label;
    setQuery(defaultPart);
    onSearch({ part_query: defaultPart, category_id: cat.id });
  };

  return (
    <div
      data-testid="part-search-section"
      className="surface-card animate-slide-up rounded-2xl p-6 sm:p-8"
    >
      <div className="mb-5 flex items-center justify-between gap-4">
        <div>
          <span className="font-mono text-[11px] uppercase tracking-widest text-cyan-400">
            Étape 2 · Pièce recherchée
          </span>
          <h3 className="mt-1 font-heading text-2xl font-bold text-slate-50">
            Quelle pièce cherchez-vous ?
          </h3>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3 sm:flex-row">
        <div className="relative flex-1">
          <Search className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-500" />
          <Input
            data-testid="part-search-input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Ex. plaquettes de frein avant, filtre à huile, courroie de distribution..."
            className="h-14 border-slate-700 bg-slate-900/60 pl-12 text-base text-slate-100 placeholder:text-slate-500 focus-visible:ring-cyan-500"
          />
        </div>
        <Button
          data-testid="part-search-submit"
          type="submit"
          size="lg"
          disabled={loading || !query.trim()}
          className="h-14 gap-2 bg-cyan-500 px-8 text-base font-semibold text-slate-950 hover:bg-cyan-400"
        >
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Search className="h-5 w-5" />}
          Comparer
        </Button>
      </form>

      <div className="mt-6">
        <div className="mb-3 font-mono text-[11px] uppercase tracking-widest text-slate-500">
          Catégories courantes
        </div>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => {
            const Icon = ICONS[cat.icone] || Cog;
            const active = activeCat === cat.id;
            return (
              <button
                key={cat.id}
                data-testid={`category-chip-${cat.id}`}
                type="button"
                onClick={() => handleCategory(cat)}
                className={`group inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-all duration-300 ${
                  active
                    ? "border-cyan-500/60 bg-cyan-500/15 text-cyan-200 shadow-[0_0_20px_rgba(6,182,212,0.25)]"
                    : "border-slate-700 bg-slate-900/60 text-slate-300 hover:border-cyan-500/40 hover:bg-slate-800 hover:text-cyan-300"
                }`}
              >
                <Icon className="h-4 w-4" strokeWidth={2} />
                {cat.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
